export enum IssuanceMonitorTab {
    Deals = 'deals',
    Dashboard = 'dashboard',
    IOIs = 'iois',
    ArrangerPipeline = 'arrangerPipeline',
    ArrangerPipelineEdit = 'arrangerPipelineEdit',
}
